import React from "react";
import { spacing } from "../../../../stitches.config";
import { Box } from "../../../Common/__styles__/Layout";
import Divider from "../../../Common/Divider";
import { Title } from "../../../Common/Typography";
import { Header, MenuOptionContainer } from "./__styles__/Operations";
import AccountActivityMenu from "./AccountActivityMenu";
import AccountBoundaryMenu from "./AccountBoundaryMenu";
import BulkPropertyActionMenu from "./BulkPropertyActionMenu";

const Operations = () => {
  return (
    <Box>
      <Header>
        <Title size="small" type="semiBold">
          Operations
        </Title>
      </Header>
      <MenuOptionContainer>
        <BulkPropertyActionMenu />
        <Divider margins={`${spacing.l.toString()} 0`} />
        <AccountActivityMenu />
        <Divider margins={`${spacing.l.toString()} 0`} />
        <AccountBoundaryMenu />
      </MenuOptionContainer>
    </Box>
  );
};

export default Operations;
